import { environmentFromHost, isQAEnviroment } from 'shared/environment-helpers'
import { isBrazil } from './country'

const environment = environmentFromHost()

const dev = __DEV__
const ca = environment === 'ca'
const be = environment === 'be'
const lu = environment === 'lu'
const es = environment === 'es'
const uk = environment === 'uk'

const countryPurchaseFlow = window.COUNTRY_PURCHASE_FLOW?.toLowerCase()

const isCanadaPurshaseFlow = countryPurchaseFlow === 'ca'
const isBrazilPurshaseFlow = countryPurchaseFlow === 'br'

const qa = isQAEnviroment()

const featureToggles = {
    // business logic
    showCookiePolicy: !!window.SHOW_COOKIE_POLICY,

    // Auth
    newAuthFlow: !!window.USE_THINX_API,
    additionalSignupData: isBrazilPurshaseFlow,
    confirmSignUpEmail: dev || uk || qa || be || lu || es || false,
    requiresPhoneNumberDuringSignUp: isBrazil,

    // Map
    showOpngoResults: isBrazilPurshaseFlow && !isCanadaPurshaseFlow,
    hasSearchBar: !isBrazil,
    canFilterByVehicleTypes: !isBrazil,

    // Buying
    newSubscriptionFlow: isBrazilPurshaseFlow || isCanadaPurshaseFlow,
    bookingRedirect: isBrazil,

    // if we remove canada subscription flow code, following line will be removed as well
    caPurchaseFlow: isCanadaPurshaseFlow,
    newSubscriptionDashboard: isCanadaPurshaseFlow,
    nifRequired: es || false,
    hasPrepaidFlow: !!window.HAS_PREPAID_FLOW,
    supportsDebitCard: !isBrazil,
    hasEventFlow: ca || false,
    isRenewSubscriptionAlways: isBrazil,
    showAllExceptCanada: !ca,

    // dev tools
    hasHotModuleReplacement: dev || false,
    hasReduxDevTools: dev || qa || false,

    // address form
    newAddressFormUX: !!window.USE_THINX_API || isBrazil,

    // general
    hasBasket: !isBrazil,
    hasReminders: isBrazil,
    showDownloadApp: !isBrazil,
    hasSubcriptionLite: isCanadaPurshaseFlow,
}

export default featureToggles
